import { actionGenerator, IReduxAction } from '../../utils/actions';
import { IRecommendedPackage } from '../../types/reducers/recommendedPackages';
import {
  IPaidPublicationState,
  IPromotionState,
  IPublicationPackagesState,
  TMoneySourcesState,
} from '../../reducers/v2';

export const LOAD_PUBLISH_TERMS_SUCCESS = 'PUBLISH_TERMS :: LOAD_SUCCESS';

export interface IPublishTermsSuccessPayload {
  dataV2: IDataV2;
}

interface IDataV2 {
  paidPublication: IPaidPublicationState;
  recommendedPackages: IRecommendedPackage[];
  publicationPackages: IPublicationPackagesState;
  promotion: Omit<IPromotionState, 'isChangedByUser'>;
  moneySources: TMoneySourcesState;
}

export type TLoadPublishTermsSuccessAction = IReduxAction<
  typeof LOAD_PUBLISH_TERMS_SUCCESS,
  IPublishTermsSuccessPayload
>;

export const loadPublishTermsSuccess = actionGenerator<typeof LOAD_PUBLISH_TERMS_SUCCESS, IPublishTermsSuccessPayload>(
  LOAD_PUBLISH_TERMS_SUCCESS,
);
